import { useEffect, useState } from 'react'

import AddIcon from '@material-ui/icons/Add'
import GetAppIcon from '@material-ui/icons/GetApp'
import SetState from 'Components/Hooks/SetState'
import NavBarGlobal from 'Components/UI/Molecules/NavBar'
import ReceiptTable from 'Components/UI/Organisms/Sales/Receipt'
import CreateReceipt from 'Components/UI/Organisms/Sales/Receipt/Create'
import ExportReceipt from 'Components/UI/Organisms/Sales/Receipt/Export'
import TemplateGlobal from 'Components/UI/Templates/Common'
import { oemColorButton } from 'Helpers'
import { useLocation } from 'react-router-dom'
import { getUbicacion } from 'service/helpers/localstorage'
import { interfaces } from 'service/interfaces'

const ReceiptTemplate = () => {
  const [render, setRender] = useState(true)
  const [dataBefore, setDataBefore] = useState()

  const [openExport, setOpenExport] = useState({ open: false, suspense: false })
  const [values, setValues] = useState({
    rows: [],
    header: [],
    permissions: {},
  })
  const { state: openNew, setOpen: setOpenNew, setClose: setCloseNew } = SetState()

  const location = getUbicacion() || ''
  const { pathname } = useLocation()

  const closeDialogExport = () => {
    setOpenExport({ ...openExport, open: false })
  }

  const openDialogExport = () => {
    setOpenExport({ open: true, suspense: true })
  }

  async function apiCallBefore() {
    await interfaces.salesReceipt.before().then((res) => {
      setDataBefore({
        data: res.data,
      })
    })
  }

  const permissions = dataBefore?.data.permissions

  useEffect(() => {
    apiCallBefore()
  }, [render])

  const BUTTONS = [
    {
      onClick: openDialogExport,
      menuTitle: 'Exportar',
      menuIcon: <GetAppIcon fontSize="small" />,
      buttonContent: <GetAppIcon style={{ color: 'black' }} />,
      disabled: !permissions?.export,
    },
    {
      onClick: setOpenNew,
      menuTitle: 'Nuevo',
      menuIcon: <AddIcon fontSize="small" />,
      buttonContent: 'Nuevo',
      buttonStartIcon: <AddIcon />,
      buttonStyle: permissions?.create ? oemColorButton(pathname, location) : {},
      disabled: !permissions?.create,
    },
  ]

  return (
    <div>
      <TemplateGlobal
        navbar={<NavBarGlobal title="Ventas" subTitle="Recibos" buttons={BUTTONS} />}
        table={
          <>
            <ReceiptTable
              dataBefore={dataBefore}
              values={values}
              setValues={setValues}
              render={render}
              setRender={setRender}
              permissions={permissions}
            />

            {openExport.suspense && (
              <ExportReceipt onClose={closeDialogExport} open={openExport.open} />
            )}
          </>
        }
      />
      {openNew.suspense && (
        <CreateReceipt
          open={setOpenNew}
          handleClose={setCloseNew}
          render={render}
          setRender={setRender}
        />
      )}
    </div>
  )
}

export default ReceiptTemplate
